import CenteredHeader from "./../../Molecules/CenteredHeader/CenteredHeader";
import IndustryImageTextSection from "../../Molecules/IndustryImageTextSection/IndustryImageTextSection";
import IndustryLightBlueSection from "./../../Organisms/IndustryLightBlueSection/IndustryLightBlueSection";
import auto from "../../../assets/img/auto.png";
import Industry_Phone from "../../../assets/img/Industry_Phone.jpg";
import Grupo1894 from "../../../assets/img/Grupo1894.png";
import IndustryBannerBgSection from "../../Atoms/IndustryBannerBgSection/IndustryBannerBgSection";
import IndustryFooterButtonSection from "./../../Atoms/IndustryFooterButtonSection/IndustryFooterButtonSection";
import IndustryTwoButtonsSection from "./../../Atoms/IndustryTwoButtonsSection/IndustryTwoButtonsSection";
import MANEJO_DE_FLOTAS_CARACTERISTICAS_IMG from "../../../assets/img/MANEJO_DE_FLOTAS_CARACTERISTICAS_IMG.jpg";
import MANEJO_DE_FLOTAS_ROUTE_CENTER_IMG from "../../../assets/img/MANEJO_DE_FLOTAS_ROUTE_CENTER_IMG.jpg";
import content from "./content";
import { useLanguageCtx } from "../../../store/providers/LanguageContext";
import ChangeableHeaderV2 from "../../Molecules/ChangeableHeaderV2/ChangeableHeaderV2";
import { useScrollCtx } from "../../../store/providers/ScrollContext";

const IndustryManejoDeFlotas = () => {
	const {language} = useLanguageCtx();
	const { dropdownHeader } = useScrollCtx();
	return (
		<>
			<ChangeableHeaderV2
				titleBanner={content[language].header_title}
				spanTitleYellow={content[language].header_title_yellow}
				appearSecondNavbar={dropdownHeader}
			/>
			<div className="top-space-section">
				<CenteredHeader
					yellowText={content[language].flotas_red_title}
					boldText={content[language].flotas_bold_title}
				/>
			</div>

			<div className="top-space-section bottom-space-section">
				<IndustryImageTextSection
					image={{ img: auto, alt: "Auto" }}
					boldText={content[language].flotas_bold_text}
					paragraphs={content[language].flotas_text}
				/>
			</div>

			<IndustryLightBlueSection
				checkText={content[language].beneficios_list}
				yellowText={content[language].beneficios_red_title}
				boldText={content[language].beneficios_bold_text}
			/>

			<div className="pb-80 top-space-section">
				<IndustryImageTextSection
					yellowText={content[language].caracteristicas_red_title}
					boldText={content[language].caracteristicas_bold_title}
					checkText={content[language].caracteristicas_list}
					image={{ img: Industry_Phone, alt: "Phone" }}
					// imgShadow
					imgRadius
					switchOrder
				/>
			</div>

			<IndustryBannerBgSection route="flotas" laptopImg>
				<IndustryImageTextSection
					switchOrder
					funciones
					yellowText={content[language].funcionalidades_red_title}
					boldText={content[language].funcionalidades_bold_text}
					paragraphs={content[language].funcionalidades_text}
				/>
			</IndustryBannerBgSection>

			<IndustryTwoButtonsSection bgColor="#F0F3F7" extraTopPadding />

			<div className="top-space-section bottom-space-section padding light-blue-bg">
				<div className="bottom-space-section no-bottom-space-responsive">
					<CenteredHeader
						yellowText={content[language].dashboard_red_title}
						boldText={content[language].dashboard_bold_title}
					/>
				</div>
				<IndustryImageTextSection
					image={{ img: Grupo1894, alt: "Tablet" }}
					boldText={content[language].dashboard_bold_text}
					paragraphs={content[language].dashboard_text}
					checkText={content[language].dashboard_list}
					responsiveImgPosition="last"
				/>
			</div>

			<div className="top-space-section">
				<IndustryImageTextSection
					switchOrder
					imgRadius
					image={{
						img: MANEJO_DE_FLOTAS_CARACTERISTICAS_IMG,
						alt: "Laptop con Mapa en Pantalla",
					}}
					yellowText={content[language].caracteristicas_red_title}
					boldText={content[language].caracteristicas_bold_title}
					checkText={content[language].caracteristicas_list}
				/>
			</div>

			<div className="top-space-section">
				<CenteredHeader
					yellowText={content[language].router_red_title}
					boldText={content[language].router_bold_title}
				/>
			</div>

			<div className="top-space-section no-top-space-responsive bottom-space-section">
				<IndustryImageTextSection
					image={{
						img: MANEJO_DE_FLOTAS_ROUTE_CENTER_IMG,
						alt: "Tablet con Mapa en Pantalla",
					}}
					imgRadius
					// imgShadow
					boldText={content[language].router_bold_text}
					paragraphs={content[language].router_text}
					checkText={content[language].router_list}
					responsiveImgPosition="last"
				/>
			</div>

			<IndustryFooterButtonSection />
		</>
	);
};

export default IndustryManejoDeFlotas;
